import { render, staticRenderFns } from "./GStudentRecordValueCell.vue?vue&type=template&id=3268b719&scoped=true&"
import script from "./GStudentRecordValueCell.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordValueCell.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordValueCell.vue?vue&type=style&index=0&id=3268b719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268b719",
  null
  
)

export default component.exports